import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { AssistantPanel } from './AssistantPanel';
import { DemoBanner } from './DemoBanner';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

export function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-canvas">
      {/* First tab stop on every page. Keyboard users should not have to walk the
          whole navigation to reach the content on each new screen. */}
      <a
        href="#main"
        className="sr-only-focusable fixed left-3 top-3 z-50 rounded bg-primary px-3 py-2 text-sm font-medium text-primary-ink"
      >
        Skip to content
      </a>

      <Sidebar open={sidebarOpen} onNavigate={() => setSidebarOpen(false)} />

      <div className="lg:pl-60">
        <DemoBanner />
        <TopBar onOpenSidebar={() => setSidebarOpen(true)} />
        <main id="main" tabIndex={-1} className="mx-auto max-w-[1400px] px-4 py-6">
          <Outlet />
        </main>
      </div>

      {/* Renders nothing unless the server says the assistant is switched on. */}
      <AssistantPanel />
    </div>
  );
}
